import { scorecardService } from '@services/api';
import { queryKeys } from '@services/query.config';
import { useStore } from '@store/index';
import { useQuery } from '@tanstack/react-query';

import { QC_EVAL_DETAIL_QUERY_CONFIG } from '@/constants/queryConfig';

export const useScorecard = (
  programId: string | null | undefined,
  scorecardId: string | null | undefined,
) => {
  const selectedOrganizationId = useStore(state => state.selectedOrganizationId);

  return useQuery({
    queryKey: queryKeys.scorecards.byId(scorecardId || '', programId || undefined),
    queryFn: () =>
      scorecardService.getScorecard({
        organization_id: selectedOrganizationId!,
        program_id: programId!,
        scorecard_id: scorecardId!,
      }),
    enabled: !!selectedOrganizationId && !!programId && !!scorecardId,
    ...QC_EVAL_DETAIL_QUERY_CONFIG,
  });
};
